export enum LangType {
    PYTHON = "PYTHON",
    PYTHON_DS = "PYTHON_DS",
    PYTHON_DL = "PYTHON_DL",
    PYTHON_DL_GPU = "PYTHON_DL_GPU",
    PYTORCH = "PYTORCH",
    JAVA = "JAVA",
    SPRINGBOOT = "SPRINGBOOT",
    EXPRESS = "EXPRESS",
    CPP = "CPP",
    C = "C",
    CSHARP = "CSHARP",
    SQL_POSTGRESQL = "SQL_POSTGRESQL",
    SQL_MYSQL_V8 = "SQL_MYSQL_V8",
    SQL_MYSQL = "SQL_MYSQL",
    SQL_ORACLE = "SQL_ORACLE",
    JAVASCRIPT = "JAVASCRIPT",
    JAVASCRIPT_XML = "JAVASCRIPT_XML",
    TYPESCRIPT = "TYPESCRIPT",
    TYPESCRIPT_XML = "TYPESCRIPT_XML",
    HTML_CSS_JAVASCRIPT = "HTML_CSS_JAVASCRIPT",
    LINUX = "LINUX",
    DOCKER = "DOCKER",
    CSS = "CSS",
    LLM = "LLM",
    GOLANG = "GOLANG",
    HUGGINGFACE = "HUGGINGFACE",
    AWS = "AWS",
    PROMPT_GRADIO = "PROMPT_GRADIO",
    AGENT_PROMPT = "AGENT_PROMPT",
    SAGEMAKER_GPU = "SAGEMAKER_GPU",
    SAGEMAKER_CPU = "SAGEMAKER_CPU",
    VUE = "VUE",
    GROOVY = "GROOVY",
    YAML = "YAML",
    SHELL = "SHELL",
    LANGGRAPH = "LANGGRAPH",
    KOTLIN = "KOTLIN",
    EMBED = "EMBED",
    EMBED_GPU_TENSORFLOW = "EMBED_GPU_TENSORFLOW",
    EMBED_GPU_PYTORCH = "EMBED_GPU_PYTORCH",
    EMBED_GPU_HUGGINGFACE = "EMBED_GPU_HUGGINGFACE",
    EMBED_GPU_JUPYTER_HUGGINGFACE = "EMBED_GPU_JUPYTER_HUGGINGFACE",
    EMBED_OPENCODE = "EMBED_OPENCODE"
}
